import * as React from 'react';
import { connect } from 'react-redux';
import { Store } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { match } from 'react-router-dom';
import { loadAllStylesLandingPage, LoadAllStylesLandingPageData } from '../../actions/all-styles-landing-page';
import { AllStylesLandingPageData, StoreState } from '../../types';
import AllStylesLandingPage from './AllStylesLandingPage';
import { Helmet } from 'react-helmet';
import { AnalyticsEvent, logEvent } from '@weddingspot/ws-analytics';
import { ComponentForSSR } from '../../types/ComponentForSSR';

interface ActionProps {
    load: () => Promise<AllStylesLandingPageData>;
}

interface StateProps {
    data: AllStylesLandingPageData;
}

type Props = ActionProps & StateProps;

class AllStylesLandingPageContainer extends ComponentForSSR<Props, {}> {
    static fetchData(store: Store<StoreState>): Promise<any> {
        const storeDispatch = store.dispatch as ThunkDispatch<StoreState, undefined, LoadAllStylesLandingPageData>;
        return storeDispatch(loadAllStylesLandingPage());
    }

    componentDidMount() {
        this.props.load().then((res) => {
            logEvent(AnalyticsEvent.EVTNM_VISITED_ALL_STYLES_PAGE, {});
        });
    }

    render() {
        return (
            <>
                <Helmet
                    title={'Discover wedding venues by style, from barn to rustic to outdoor'}
                    meta={[
                        {
                            name: 'description',
                            content:
                                'Browse venues in a variety of styles: Barns, Rustic, Outdoor, Waterfront Views, Wineries, Mansions, Parks, Historic Landmarks, Ballrooms, Beaches, and more.',
                        },
                    ]}
                />
                <AllStylesLandingPage data={this.props.data} />
            </>
        );
    }
}

const mapStateToProps = (state: StoreState, ownProps: {}): StateProps => ({
    data: state.allStylesLandingPageData,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<StoreState, undefined, LoadAllStylesLandingPageData>): ActionProps => ({
    load: () => dispatch(loadAllStylesLandingPage()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AllStylesLandingPageContainer);
